/* eslint-disable */

export enum SocialChannel {
	Facebook = 0,
	Youtube = 1,
	Instagram = 2,
	LinkedIn = 3,
	Pinterest = 4,
	None = 5,
	
}
